import { Close, Save } from "@mui/icons-material";
import { IconButton, Stack, TextField } from "@mui/material";
import { useState } from "react";
import { txt } from "../../../services/translation";


export default function TitleForm({label, title, onSubmit, onCancel}){

    const [value, setValue] = useState(title)

    const formStyle = {flex: 1, display: 'flex', flexDirection: 'column'};

    const handleSubmit = e => {
        e.preventDefault();
        return onSubmit(value);
    }

    return <form style={formStyle} onSubmit={handleSubmit}>

        <Stack direction='row' alignItems='center'>

            <TextField 
                label={label || txt('title')}
                value={value}
                onChange={e => setValue(e.target.value)}
                size='small'
                required
                variant='standard'
                autoFocus={true}
                sx={{flex:1}}
                inputProps={{maxLength: 255}}
            />

            <Stack direction='row'>
                <IconButton size='small' color='primary' type='submit'>
                    <Save/>
                </IconButton>

                <IconButton size='small' color='error' onClick={onCancel}>
                    <Close/>
                </IconButton>
            </Stack> 

        </Stack>
    </form>
}